/*
 *
 * MsDynamicsVerify actions
 *
 */

import { VERIFY_MS_DYNAMICS } from './constants';
import { defineAction } from 'utils/action-helper';

export const verifyMsDynamics = {
  start: () => defineAction({ type: VERIFY_MS_DYNAMICS.START }),
  success: () => defineAction({ type: VERIFY_MS_DYNAMICS.SUCCESS }),
  error: ({ error }) =>
    defineAction({
      type: VERIFY_MS_DYNAMICS.ERROR,
      payload: {
        error,
      },
    }),
};
